import { Card, Icon, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import { IApproveToPayTab, ICollectRequestDetails } from 'types';
import thumbsUp from 'assets/icons/Autopay/thumbsUp.svg';
import { WatchLaterRounded, WarningRounded, Cancel } from '@bharatpe/bharat-ui';
import { isEmpty } from 'utils/Utils';
import noTransactionsIcon from 'assets/images/autoPay/noTransactionsIcon.svg';

const CompletedTab: React.FC<IApproveToPayTab> = ({ paymentRequestItem, transactionLoading }) => {
	const getStripDOM = (status: string, lastTransactionAmount: string) => {
		switch (status) {
			case 'ACTIVE':
			case 'HONORED':
				return (
					<>
						<img className="mr2" src={thumbsUp} height={12} width={12} />
						<Typography variant="Regular200" className="grey">
							₹{lastTransactionAmount} - last paid
						</Typography>
					</>
				);
			case 'PENDING':
			case 'INITIATED':
				return (
					<>
						<Icon icon={WatchLaterRounded} className={`pending-logo mr2`} height={14} width={14} />
						<Typography variant="Regular200" className="grey">
							AutoPay setup in progress
						</Typography>
					</>
				);
			case 'FAILED':
				return (
					<>
						<Icon icon={WarningRounded} className={`failed-logo mr2`} height={14} width={14} />
						<Typography variant="Regular200" className="grey">
							Unable to set up an AutoPay
						</Typography>
					</>
				);
			case 'REVOKED':
				return (
					<>
						<Icon icon={Cancel} className={`grey-logo mr2`} height={14} width={14} />
						<Typography variant="Regular200" className="grey">
							AutoPay has been cancelled
						</Typography>
					</>
				);
		}
	};

	useEffect(() => {
		console.log('paymentRequestItem', paymentRequestItem);
	}, [paymentRequestItem]);

	if (paymentRequestItem == undefined || isEmpty(paymentRequestItem))
		return (
			<div className="mx5 mt6 mandate-list text-center">
				<Card className="p4 mb5 mt5 flex flex-column flex-center mb4">
					<img src={noTransactionsIcon} />
					<Typography variant="Bold500">No transactions</Typography>
					<Typography variant="Light200" className="grey mt2">
						You haven’t made any transactions yet
					</Typography>
				</Card>
			</div>
		);
	return (
		<div className="mx5 mt6 mandate-list text-center">
			{paymentRequestItem?.map((item: ICollectRequestDetails, idx: number) => {
				return (
					<Card className="p4 mb5 mt5 flex flex-column flex-center mb4" key={idx}>
						<div className="flex flex-row flex-justify width-100">
							<div className="flex flex-row">
								<img src={item?.payee_details?.payee_logo} className="circular-logo" />

								<div className="ml2 flex-start width-75">
									<Typography variant="Regular300" className="text-ellipsis1 text-left">
										{item?.payee_details?.name}
									</Typography>
									<Typography variant="Regular100" className="grey mt1 text-ellipsis text-left">
										{item?.payee_details?.vpa}
									</Typography>
								</div>
							</div>
							<Typography variant="Bold400" className="grey mt1 text-ellipsis text-left">
								₹{item?.amount}
							</Typography>
						</div>
						<div className="flex flex-row flex-justify flex-center width-100">
							<div className="flex flex-row flex-center"></div>
						</div>
					</Card>
				);
			})}

			{/* // ))} */}
		</div>
	);
};
export default CompletedTab;
